import React from 'react';
import { observer } from 'mobx-react';
import { FormWrapper, FieldsWrapper } from 'libs/forms/styles';
import { confToFields } from 'libs/forms/index';
import { Box } from 'components';
import { Section, SectionContent } from '../../shared/layout';

const rowStyles = {
  display: 'flex',
  alignItems: 'center',
};

export const ShipmentQuoteDetails = observer(
  ({ shipmentQuoteFormStore }: { shipmentQuoteFormStore: any }) => {
    return (
      <Section title='Quote Details'>
        <SectionContent>
          <Box sx={rowStyles}>
            <FormWrapper noPadding responsive>
              <FieldsWrapper formColumns={3}>
                {confToFields({
                  formStore: shipmentQuoteFormStore,
                  refs: {},
                  responsive: true,
                  fields: ['manufacturer', 'currency', 'validUntil'],
                })}
              </FieldsWrapper>
            </FormWrapper>
          </Box>
        </SectionContent>
        <SectionContent>
          <FormWrapper noPadding ml={0}>
            <FieldsWrapper formColumns={2}>
              {confToFields({
                formStore: shipmentQuoteFormStore,
                refs: {},
                responsive: true,
                fields: ['takeRate', 'downPayment', 'secondPaymentDue'],
              })}
            </FieldsWrapper>
          </FormWrapper>
        </SectionContent>
        <SectionContent>
          <Box sx={rowStyles}>
            <FormWrapper noPadding responsive>
              <FieldsWrapper formColumns={3}>
                {confToFields({
                  formStore: shipmentQuoteFormStore,
                  refs: {},
                  responsive: true,
                  fields: ['incoterm', 'manufacturingTime', 'bufferTime'],
                })}
              </FieldsWrapper>
            </FormWrapper>
          </Box>
        </SectionContent>
      </Section>
    );
  },
);
